import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor =
  document.body.classList.contains("block-editor-page") ||
  document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initSpeakers(section) {
  if (!section || section.__spInit) return;
  section.__spInit = true;

  const eyebrow = section.querySelector(".speakers__eyebrow");
  const dot = eyebrow?.querySelector(".dot");
  const head = section.querySelector(".speakers__headline");
  const intro = section.querySelector(".speakers__intro");
  const cta = section.querySelector(".btn--accent");
  const cards = gsap.utils.toArray(section.querySelectorAll(".speaker-card"));

  const leadEls = [eyebrow, head, intro, cta].filter(Boolean);

  // initial states (filtered to avoid nulls)
  if (leadEls.length) gsap.set(leadEls, { opacity: 0, y: 18 });
  if (cards.length) gsap.set(cards, { opacity: 0, y: 26, rotateX: -2 });

  const play = () => {
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    if (eyebrow) tl.to(eyebrow, { opacity: 1, y: 0, duration: 0.45 });
    if (dot)
      tl.fromTo(
        dot,
        { scale: 0.6 },
        { scale: 1, duration: 0.35, ease: "back.out(2)" },
        "<"
      );
    if (head) tl.to(head, { opacity: 1, y: 0, duration: 0.6 }, "-=0.1");
    if (intro) tl.to(intro, { opacity: 1, y: 0, duration: 0.5 }, "-=0.2");
    if (cta) tl.to(cta, { opacity: 1, y: 0, duration: 0.45 }, "-=0.2");

    if (cards.length) {
      // If there were no lead tweens, start cards at time 0 instead of a negative relative offset.
      const pos = leadEls.length ? "-=0.05" : 0;
      tl.to(
        cards,
        {
          opacity: 1,
          y: 0,
          rotateX: 0,
          duration: 0.55,
          stagger: 0.08,
          ease: "power2.out",
        },
        pos
      );
    }
  };

  if (isEditor) {
    play();
    return;
  }

  const st = ScrollTrigger.create({
    trigger: section,
    start: "top 80%",
    once: true,
    onEnter: play,
  });

  // If it's already in view at load, fire immediately.
  if (ScrollTrigger.isInViewport(section)) {
    play();
    st.kill();
  }
}

const mount = () => {
  document.querySelectorAll(".speakers-grid").forEach(initSpeakers);
  if (isEditor) {
    const root = document.querySelector(".editor-styles-wrapper") || document;
    const mo = new MutationObserver(() =>
      root.querySelectorAll(".speakers-grid").forEach(initSpeakers)
    );
    mo.observe(root, { childList: true, subtree: true });
  }
};

if (window?.wp?.domReady) wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
